import { Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const ClientNamePrefix: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  return (
    <Form.Item
      name="usernamePrefix"
      label="Username Prefix"
      rules={[
        {
          required: true,
          message: t("error:prefix_name_is_required"),
        },
      ]}
    >
      <Input disabled={id ? true : false} />
    </Form.Item>
  );
};

export default ClientNamePrefix;
